import React from "react";

export default function DeleteConfirmModal({ show, onClose, onConfirm, itemName }) {
  if (!show) return null;

  return (
    <div className="delete-modal">
      <div className="delete-box">

        {/* Header */}
        <div className="delete-header">
          <h2 className="title">Delete Confirmation</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {/* Message */}
        <div className="delete-content">
          <p className="message">
            Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.
          </p>
        </div>

        {/* Footer Buttons */}
        <div className="delete-footer">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
          <button className="delete-btn" onClick={onConfirm}>Delete</button>
        </div>

      </div>
    </div>
  );
}